export const CreditType = {
  SHORT_LOAN: 'Éven belüli forgóeszköz kölcsön/hitel',
  LONG_LOAN: 'Éven túli forgóeszköz kölcsön/hitel',
  INVESTMENT_LOAN: 'Beruzházási kölcsön/hitel',
  ACQUISITION_LOAN: 'Akvizíciós hitel',
  LOAN_CONVERSION: 'Hitelkiváltó hitel',
  LEASING: 'Lízing'
}

export const creditServiceProviderType = {
  MFB: 'MFB',
  KAVOSZ: 'KAVOSZ',
  EXIM: 'EXIM',
  OTHER: 'Egyéb'
}

// export default {CreditType, creditServiceProviderType}
